import { useToast } from "./ToastContext";
import { Toast } from "./Toast";
import styles from "./ToastContainer.module.scss";

/**
 * ToastContainer Component
 *
 * Container for displaying toast notifications
 * Should be placed at the root of your app
 */
export function ToastContainer() {
  const { toasts, hideToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className={styles.container} aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={hideToast} />
      ))}
    </div>
  );
}
